export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? `${window.location.protocol}//${window.location.hostname}`
    : "https://www.luxecraftshop.com"; // 在本地开发时也调用线上后端

const endpoints = {
  SENDMESSAGE: "/api/order/send_kf_2",
  FACEBOOK: "/api/facebook/EventsAll",
};

export default endpoints;
